import { PERMISSIONS } from '../auth/permissions/catalog';

/**
 * Permission vocabulary of the Observability module (PRD - Observability,
 * Feature 4): one level to enter the module and read the aggregated runs, another
 * to open a run's detail (turns, transcript, steps and calls).
 *
 * The feature declares them here instead of reaching for the global catalog, so
 * every access rule of the log is readable — and changeable — in one place.
 *
 * Why both still read `agent.view`: `can()` (see
 * `features/auth/context/AuthContext.tsx`) is an exact-string lookup against the
 * set the backend sends at login, and the log's own permissions are not seeded
 * yet (AGE-362). An invented `agent.observability.view` would deny the module to
 * everyone but a superadmin. Meanwhile the log inherits the agent's access — the
 * very thing the PRD rules out — which is acceptable only because the module
 * ships behind `REACT_APP_FEATURE_OBSERVABILITY`, off in PROD.
 *
 * TODO(AGE-362): when the seed lands, this object is the only edit.
 */
export const OBSERVABILITY_PERMISSIONS = {
  /** Enter the module and read the list with its figures. */
  view: PERMISSIONS.agent.view,
  /**
   * Open a run's detail: the page reads it for the rows of both sections — a
   * conversation's turns (AGE-359) and a process run's steps (AGE-360). A UX gate only — the detail
   * read must authorize this permission, and record the access, server-side.
   */
  viewDetail: PERMISSIONS.agent.view,
} as const;

/** Any permission string of this module. */
export type ObservabilityPermission =
  (typeof OBSERVABILITY_PERMISSIONS)[keyof typeof OBSERVABILITY_PERMISSIONS];
